(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mtc-collection-intro"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-mtc-intro-toggle]');
    if (!toggle) return;

    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;

    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    toggle.textContent = expanded ? toggle.dataset.labelMore : toggle.dataset.labelLess;
    panel.hidden = expanded;
  });
  } catch(e) { console.error(e); }
})();

})();
